export const managerLearningStates = { NOT_STARTED: '인정 진도 없음', IN_PROGRESS: '학습 진행 중', FULL_PROGRESS: '진도 100%', REVIEW_REQUIRED: '진도 검토 필요' }
export const managerLearningLabel = value => managerLearningStates[value] || '진도 미확인'
